import { render } from "./planningTicket.vue?vue&type=template&id=11858d36"
import script from "./planningTicket.vue?vue&type=script&lang=ts"
export * from "./planningTicket.vue?vue&type=script&lang=ts"
script.render = render

export default script